import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { Pagination } from '../../shared/components/pagination/models/pagination.model';
import { PaginationArgs } from '../../shared/components/pagination/models/pagination-args.model';
import { MessageResponse } from '../../shared/models/message-response.model';

import { OrganizationDto } from './dtos/organization';

@Injectable({
	providedIn: 'root',
})
export class OrganizationsService {
	private readonly endpoint: string = `${environment.apiUrl}/organization`;

	constructor(private readonly http: HttpClient) {}

	findMany(args: PaginationArgs): Observable<Pagination<OrganizationDto>> {
		return this.http.get<Pagination<OrganizationDto>>(`${this.endpoint}/v2`, {
			params: args.buildHttpParams(),
		});
	}

	getById(id: string): Observable<OrganizationDto> {
		return this.http.get<OrganizationDto>(`${this.endpoint}/${id}`);
	}

	toggleFavorite(
		organizationId: string,
		current: boolean,
	): Observable<MessageResponse> {
		const url = `${this.endpoint}/${current ? 'unfavorite' : 'favorite'}`;

		return this.http.post<MessageResponse>(url, { organizationId });
	}

	togglePasswordExpiration(
		organizationId: string,
	): Observable<MessageResponse> {
		const url = `${this.endpoint}/${organizationId}/password-expires`;

		return this.http.post<MessageResponse>(url, {});
	}

	toggleTwoFactorAuth(organizationId: string): Observable<MessageResponse> {
		const url = `${this.endpoint}/${organizationId}/two-factor`;

		return this.http.post<MessageResponse>(url, {});
	}
}
